import { render, staticRenderFns } from "./IconNewspaperOutline.vue?vue&type=template&id=77b0b744"
import script from "./IconNewspaperOutline.vue?vue&type=script&lang=js"
export * from "./IconNewspaperOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports